import React, { useState, useEffect } from 'react';

function TradersPage() {
  const [traders, setTraders] = useState([]);
  const [savedTraders, setSavedTraders] = useState([]);
  const [newWallet, setNewWallet] = useState('');


  useEffect(() => {
    fetch('/api/traders')
      .then((res) => res.json())
      .then((data) => setTraders(data))
      .catch((err) => console.error('Error load traders:', err));

  }, []);

  useEffect(() => {
    fetch('/api/saved-traders')
      .then((res) => res.json())
      .then((data) => setSavedTraders(data))
      .catch((err) => console.error('Oshibka zagruzki savedTraders:', err));
  }, []);


  const handleFollow  = (trader) => {
    const alreadySaved = savedTraders.some((t) => t.wallet === trader.wallet);
    if (alreadySaved) {
      alert('Etot treider uze v sohranjonnih');
      return;
    }

    const newSaved = { wallet: trader.wallet, comment: '' };

    fetch('/api/saved-traders/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(newSaved),
  })
    .then((res) => {
      if (res.ok) {
        setSavedTraders((prev) => [newSaved, ...prev]);
        alert('Treider dobavlen v Saved Traders');
      } else {
        alert('Oshibka: ne udalosj sohranitj treidera');
      }
    })
    .catch(() => alert('Oshibka seti pri sohranenii treidera'));
  };


const saveTraderComment = (wallet, comment) => {
  fetch('/api/traders/comment', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ wallet, comment }),
  })
  .then(res => {
    if (!res.ok) {
      console.error('Ошибка сохранения комментария trader');
    }
  })
  .catch(err => console.error('Network error:', err));
};



  const handleAddWallet = () => {
    const wallet = newWallet.trim();
    if (!wallet) return;
    const alreadyExists = traders.some((t) => t.wallet === wallet);
    if (alreadyExists) {
      alert( 'Etot kosheljok uze estj v spiske');
      return;
    }
      setTraders((prev) => [{ wallet }, ...prev]);
      setNewWallet('');

    fetch('/api/traders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ wallet }),
    })
      .then((res) => {
        if (!res.ok) {
          console.error( 'Oshibka pri sohranenii treidera na server');
        }
      })
      .catch((err) => console.error('Oshibka seti:', err));
    };



  const handleDelete = (wallet) => {
  if (!window.confirm('Delete this trader?')) return;

  // 1. СРАЗУ убрать из UI
  setSavedTraders(prev =>
    prev.filter(t => t.wallet !== wallet)
  );

  // 2. Потом удалить на сервере
  fetch(`/api/saved-traders/${encodeURIComponent(wallet)}`, {
    method: 'DELETE'
  })
  .then(res => {
    if (!res.ok) {
      alert('Delete failed on server');
    }
  })
  .catch(() => alert('Network error'));
};




  const saveComment = (wallet, comment) => {
    fetch(`/api/saved-traders/${wallet}` , {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ comment }),
    })
      .then((res) => {
        if (!res.ok) {
          console.error('Oshibka pri sohranenii komentarija');
        }
      })
      .catch((err) => {
        console.error('Oshibka seti pri soxranenii komentarija:', err);
      });
    };



  return (
    <div
      style={{
      backgroundColor: '#1e1e1e',
      color: 'white',
      minHeight: '100vh',
      padding: '40px',
      fontFamily: 'sans-serif',
    }}
  >
    <h1 style={{ fontSize: '2rem', marginBottom: '20px' }}>Search Traders</h1>

  {/* Vvod treidera vrucnuju */}
  <div style={{ marginBottom: '20px' }}>
    <input
      type="text"
      value={newWallet}
      onChange={(e) => setNewWallet(e.target.value)}
      placeholder="Enter wallet address"
      style={{
        padding: '8px',
        width: '300px',
        marginRight: '10px',
        borderRadius: '4px',
        border: '1px solid #ccc'
      }}
    />
    <button
      onClick={handleAddWallet}
      style={{
        backgroundColor: '#10b981',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '8px 16px',
        cursor: 'pointer',
        fontWeight: 'bold'
      }}
    >
      Add Wallet
    </button>
  </div>

    <div style={{ maxHeight: '360px', overflowY: 'auto' }}>
     <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
       <colgroup>
         <col style={{ width: '40%' }} />
         <col style={{ width: '54%' }} />
         <col style={{ width: '6%' }} />
       </colgroup>
       <thead>
         <tr style={{ backgroundColor: '#2c2c2c' }}> 
           <th>Wallet</th>
           <th>Comment</th>
           <th>Action</th>
         </tr>
       </thead>
       <tbody>
          {traders.slice(0).map((trader) => { 
           return (
             <tr key={trader.wallet}>
               <td style={{ padding: '8px', border: '1px solid #444' }}>{trader?.wallet || ''}</td>
               <td style={{ padding: '8px', border: '1px solid #444' }}>
                 <input
  type="text"
  value={trader.comment || ''}
  onChange={(e) => {
    const value = e.target.value;
    setTraders(prev =>
      prev.map(t =>
        t.wallet === trader.wallet
          ? { ...t, comment: value }
          : t
      )
    );
  }}
  onBlur={(e) => saveTraderComment(trader.wallet, e.target.value)}
  style={{
    width: '100%',
    padding: '4px',
    backgroundColor: '#1e1e1e',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    boxSizing: 'border-box'
  }}
/>
          </td>
               <td style={{ padding: '8px', border: '1px solid #444', textAlign: 'center' }}>
                 <button
                   onClick={() => handleFollow(trader || {})}
                   style={{
                     backgroundColor: '#10b981',
                     color: 'white',
                     border: 'none',
                     borderRadius: '4px',
                     padding: '4px 10px',
                     cursor: 'pointer',
                     fontWeight: 'bold',
                   }}
                 >
                   Follow
                 </button>
               </td>
             </tr>
            );
           })}
     </tbody>
   </table>
  </div>




        <h2 style={{ fontSize: '1.5rem', marginTop: '40px', marginBottom: '20px' }}>Saved Traders</h2>

        <div style={{
          maxHeight: '300px',
          overflowY: 'auto',
          border: '1px solid #444',
          borderRadius: '6px',
          marginTop: '10px'
        }}>

        <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <thead>
            <tr style={{ backgroundColor: '#2c2c2c' }}>
              <th style={{ padding: '8px', border: '1px solid #444' }}>Wallet</th>
              <th style={{ padding: '8px', border: '1px solid #444' }}>Comment</th>
              <th style={{ width: '80px', padding: '8px', border: '1px solid #444' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {savedTraders.length === 0 ? (
              <tr>
                <td colSpan="3" style={{ padding: '8px', textAlign: 'center', color: '#999' }}>
                  No saved traders yet
                </td>
              </tr>
            ) : (
              savedTraders.map((trader) => (
                <tr key={trader.wallet}>
                  <td style={{ padding: '8px', border: '1px solid #444', wordBreak: 'break-all' }}>
                    {trader.wallet}
                  </td>

                  <td style={{ padding: '8px', border: '1px solid #444' }}>
                    <input
                      type="text"
                      maxLength={80}
                      value={trader.comment || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                          setSavedTraders(prev =>
                            prev.map(t =>
                              t.wallet === trader.wallet
                                ? { ...t, comment: value }
                                : t
                          )
                        );
                      }}
                      onBlur={(e) => {
                        saveComment(trader.wallet, e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          saveComment(trader.wallet, e.target.value);
                          e.target.blur();
                        }
                      }}
                      placeholder="Comment"
                      style={{
                        width: '100%',
                        height: '100%',
                        padding: '4px',
                        backgroundColor: '#1e1e1e',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        boxSizing: 'border-box'
                      }}
                    />
                  </td>

                  <td style={{
                        padding: '8px',
                        border: '1px solid #444',
                        textAlign: 'center' 
                      }}
                    >
                    <button
                      onClick={() => handleDelete(trader.wallet)}
                      style={{
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '4px 10px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  ); 
}

export default TradersPage;

